<template>
  <v-container :class="{ noSidePadding: $vuetify.breakpoint.smAndDown }">
    <template v-if="userHasErrors">
      <v-layout row wrap>
        <v-flex xs12>
          <advice color="error" class="mb-4">
            <p
              class="subheading grey--text grey--ar-1 ma-0"
              v-html="$t(`user.error.booking.${userErrorText}`)"
            ></p>
          </advice>
        </v-flex>
        <v-flex xs12 text-xs-right>
          <v-btn
            outline
            color="accent"
            class="initialize"
            round
            @click="solveUserError"
          >
            {{ $t('global.solve') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template v-else>
      <v-tabs v-model="tab" grow :hidden="isHideBookingTabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          key="reservation"
          active-class="default-class secondary white--text font-weight-bold darken-1"
          class="initialize"
        >
          {{ $t('global.bookings') }}
        </v-tab>
        <v-tab
          key="plan"
          active-class="default-class secondary white--text font-weight-bold darken-1"
          class="initialize"
        >
          {{ $t('global.plans') }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item key="reservation">
          <create-reservation
            :parking="parking"
            @on-user-error="onUserHasError"
          ></create-reservation>
        </v-tab-item>
        <v-tab-item key="plan">
          <create-plan
            :parking="parking"
            @on-user-error="onUserHasError"
          ></create-plan>
        </v-tab-item>
      </v-tabs-items>
    </template>
  </v-container>
</template>

<script>
import CreateReservation from '@/components/private/booking/CreateReservation';
import CreatePlan from '@/components/private/booking/CreatePlan';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';
import Advice from '@/components/commons/Advice';

export default {
  name: 'BookingCreateWrapper',
  props: {
    parking: {
      type: Object,
      required: true,
    },
    tabParam: {
      type: Number,
      default: 0,
    },
  },
  components: {
    [CreateReservation.name]: CreateReservation,
    [CreatePlan.name]: CreatePlan,
    [Advice.name]: Advice,
  },
  watch: {
    tabParam(value) {
      this.tab = this.tabParam;
    },
  },
  computed: {
    showBookingTab() {
      if (this.hideBookingTabs) return false;
      return !this.parking.onlySubscription;
    },
    showPlanTab() {
      return this.parking.plans.length > 0;
    },
    isHideBookingTabs() {
      if (this.hideBookingTabs) {
        return true;
      }
      return !(this.showPlanTab && this.showBookingTab);
    },
  },
  mounted() {
    if (!this.showBookingTab) {
      this.tab = 1; // subscription
      this.hideBookingTabs = true;
    }
  },
  created() {
    EventBus.$on(keys.hideBookingTabs, this.doHideBookingTabs);
  },
  destroyed() {
    EventBus.$off(keys.hideBookingTabs, this.doHideBookingTabs);
  },
  data() {
    return {
      tab: this.tabParam,
      hideBookingTabs: false,
      userHasErrors: false,
      userErrorText: '',
    };
  },
  methods: {
    doHideBookingTabs: function (params) {
      this.hideBookingTabs = params.hidden;
    },
    setTab(tabIndex) {
      this.tab = tabIndex;
    },
    onUserHasError(params) {
      this.userHasErrors = true;
      this.userErrorText = params.error;
    },
    solveUserError() {
      if (this.userErrorText === 'showErrorNoTags') {
        this.$router.push({ path: this.$i18n.t('urlProfile') });
        return;
      }

      if (this.userErrorText === 'showErrorNotActived') {
        this.$router.push({ path: this.$i18n.t('urlRegister') });
        return;
      }

      if (this.userErrorText === 'showErrorNoBalance') {
        this.$router.push({ path: this.$i18n.t('urlBuy') });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.noSidePadding {
  padding-left: 0px;
  padding-right: 0px;
}
</style>
